var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Callable } from "@renproject/utils";
import axios from "axios";
import { fixUTXO, fixUTXOs, fixValue, sortUTXOs, DEFAULT_TIMEOUT, } from "./API";
export class BitcoinDotComClass {
    constructor({ testnet = false } = {}) {
        this.endpoint = () => this.testnet
            ? "https://trest.bitcoin.com/v2/"
            : "https://rest.bitcoin.com/v2/";
        this.endpointV2 = () => this.testnet
            ? "https://explorer-tbch.api.bitcoin.com/tbch/v1"
            : "https://explorer.api.bitcoin.com/bch/v1";
        this.fetchUTXO = (txHash, vOut) => __awaiter(this, void 0, void 0, function* () {
            const url = `${this.endpointV2()}/tx/${txHash}`;
            const response = yield axios.get(`${url}`, {
                timeout: DEFAULT_TIMEOUT,
            });
            const utxo = response.data;
            return fixUTXO({
                txHash,
                amount: utxo.vout[vOut].value.toString(),
                vOut,
                confirmations: utxo.confirmations,
            }, 8);
        });
        this.fetchUTXOs = (address, confirmations = 0) => __awaiter(this, void 0, void 0, function* () {
            const url = `${this.endpointV2()}/addr/${address}/utxo`;
            const response = yield axios.get(url, {
                timeout: DEFAULT_TIMEOUT,
            });
            return fixUTXOs(response.data
                .map((utxo) => ({
                txHash: utxo.txid,
                amount: utxo.amount.toString(),
                vOut: utxo.vout,
                confirmations: utxo.confirmations,
            }))
                .filter((utxo) => confirmations === 0 ||
                utxo.confirmations >= confirmations), 8).sort(sortUTXOs);
        });
        this.fetchTXs = (address, confirmations = 0) => __awaiter(this, void 0, void 0, function* () {
            const url = `${this.endpoint().replace(/\/$/, "")}/address/transactions/${address}`;
            const { data } = yield axios.get(url, {
                timeout: DEFAULT_TIMEOUT,
            });
            const received = [];
            for (const tx of data.txs) {
                for (let i = 0; i < tx.vout.length; i++) {
                    const vout = tx.vout[i];
                    if (vout.scriptPubKey.addresses.indexOf(address) >= 0) {
                        received.push({
                            txHash: tx.txid,
                            amount: fixValue(parseFloat(vout.value), 8).toFixed(),
                            vOut: i,
                            confirmations: tx.confirmations,
                        });
                    }
                }
            }
            return received
                .filter((utxo) => confirmations === 0 || utxo.confirmations >= confirmations)
                .sort(sortUTXOs);
        });
        this.broadcastTransaction = (txHex) => __awaiter(this, void 0, void 0, function* () {
            const url = `${this.endpoint().replace(/\/$/, "")}/rawtransactions/sendRawTransaction`;
            const response = yield axios.post(url, { hexes: [txHex] }, { timeout: DEFAULT_TIMEOUT });
            if (response.data.error) {
                throw new Error(response.data.error);
            }
            return response.data[0];
        });
        this.testnet = testnet;
    }
}
export const BitcoinDotCom = Callable(BitcoinDotComClass);
//# sourceMappingURL=bitcoinDotCom.js.map